/**
 * @description 权益领取-实物订单详情界面
 * route: /nftPad/orderDetail
 * @param { * }
 *
 */

import React, {useEffect, useState} from 'react';
import {Toast} from "antd-mobile";
import './index.scss';
import moment from 'moment';
import {useLocation} from "react-router-dom";
import {getUrlAllParams} from "@/utils/publicFun";
import {hideLoading, showLoading} from "@/components/loading";
import NFTHeader from "@/components/NFTHeader";
import Empty from "@/components/empty";
import Service from '../rightsOrder/service'


export const OrderDetail = () => {
    const {search} = useLocation()
    const param = getUrlAllParams(search.slice(1)) // 获取参数
    const [addressItem, setAddressItem] = useState({})
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        initData()
    }, [])

    const initData = async () => {
        try {
            showLoading()
            setLoading(true)
            const res = await Service.benefitGetOrderDetail(+param.reqId, param?.nftNo)
            hideLoading()
            if (res.code !== '000000') throw res.msg
            setData(res.data)
        } catch (e) {
            hideLoading()
            console.log(e)
        }
        setLoading(false)
    }

    const onRemind = () => {
        Toast.show({
            icon: 'loading',
            duration: 500,
            afterClose: () => {
                Toast.show('已提醒发货')
            }
        })
    }

    return (
        <div className='order_detail_page'>
            <NFTHeader midText={`订单详情`}/>
            {(loading || !data) ? <Empty /> : (
              <div className='body_content'>
                  <div className='order_status'>{data.deliverFlag == 1 ? '已发货' : '待发货'}</div>
                  {/* 地址信息 */}
                  {data?.shippingInfo && (
                    <div className='address-item'>
                        <img src={require('../images/address_icon.png')} alt=""/>
                        <div className='address-center'>
                            <div className="user_info">
                                <span>{data.shippingInfo.consigneeName || ''}</span>
                                <span>{data.shippingInfo.consigneeNumber || ''}</span>
                            </div>
                            <div className="address-info">
                                {data.shippingInfo?.province + data.shippingInfo?.city + data.shippingInfo?.area + data.shippingInfo?.street + data.shippingInfo?.address}
                            </div>
                        </div>
                    </div>
                  )}
                  {/* 商品信息 */}
                  <div className='shop-item'>
                      <div className='item_top'>
                          <div className="left">
                              <img src={data?.rightImgUrl} alt=""/>
                          </div>
                          <div className='right'>
                              <span>{data.rightName}</span>
                              <div className="right-count">x{data?.rightQuantity}</div>
                          </div>
                      </div>
                  </div>
                  {/* 订单信息 */}
                  {data?.deliverInfo && (
                    <div className='order-info'>
                        <div>
                            <span>订单编号：</span>
                            <span>{data.deliverInfo?.deliverOrderNo || ''}</span>
                        </div>
                        <div>
                            <span>下单时间：</span>
                            <span>{data.deliverInfo?.deliverOrderDate ? moment(decodeURIComponent(data.deliverInfo.deliverOrderDate)).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                        </div>
                        <div>
                            <span>物流公司：</span>
                            <span>{data.deliverInfo?.logCo || ''}</span>
                        </div>
                        <div>
                            <span>物流单号：</span>
                            <span>{data.deliverInfo?.trackNo || ''}</span>
                        </div>
                        <div>
                            <span>发货日期：</span>
                            <span>{data.deliverInfo?.shipDate ? moment(decodeURIComponent(data.deliverInfo.shipDate)).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                        </div>
                    </div>
                  )}
                  {/* 提醒发货 */}
                  {data?.deliverFlag == 0 && (
                    <div className='remind'>
                        <span onClick={onRemind}>提醒发货</span>
                    </div>
                  )}
              </div>
            )}
        </div>
    )
}


